import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { schema as base } from '../header/header.schema'

const MESSAGES_FIELD: FieldSchema = {
  key: 'messages',
  label: 'Top bar messages',
  type: 'array',
  help: 'Shown on the left of the black top bar (phones show the first). Put *stars* around a phrase to make it bold. Without messages the announcement text is used.',
  itemSchema: [
    { key: 'text', label: 'Text', type: 'localized-string' },
    { key: 'link', label: 'Link', type: 'string' },
  ],
}
const BADGE_FIELD: FieldSchema = { key: 'badge', label: 'Badge', type: 'string', placeholder: 'New', help: 'Small label next to the item.' }
const SEARCH_PLACEHOLDER_FIELD: FieldSchema = { key: 'searchPlaceholder', label: 'Search label', type: 'string', placeholder: 'Search' }

/** Menu item type gains the Shop panel (store categories) and items gain a badge. */
const menuItemSchema = (items: FieldSchema[]): FieldSchema[] => [
  ...items.map(f => (f.key === 'type' && f.options && !f.options.some(o => o.value === 'categories')
    ? { ...f, options: [...f.options, { label: 'Shop panel (store categories)', value: 'categories' }] }
    : f)),
  BADGE_FIELD,
]

/** Mohalla header: the base fields plus top bar messages, the search label, Shop panel items and badges. */
export const schema: ComponentSchema = {
  ...base,
  commonFields: base.commonFields.flatMap((f): FieldSchema[] => {
    if (f.key === 'topbar' && f.fields) return [{ ...f, fields: [...f.fields, MESSAGES_FIELD] }]
    if (f.key === 'menu' && f.itemSchema) return [{ ...f, itemSchema: menuItemSchema(f.itemSchema) }]
    if (f.key === 'actions') return [f, SEARCH_PLACEHOLDER_FIELD]
    return [f]
  }),
}
